import { defineStore } from "pinia";
import LxcError from "~/core/models/LxcError.class";
import type { UserSession } from "~/modules/user/models/UserSession.interface";
import userService from "~/modules/user/services/user.service";
import { logout } from "~/utils/auth.utils";

export const useUserSession = defineStore("userSession", () => {
  const userSession = ref<UserSession | undefined>(undefined);
  const isAuthenticated = ref<boolean>(false);

  /**
   * Apply retrieve current user to store
   * @param route
   */
  async function setCurrentUser(): Promise<void> {
    const response = await userService.getCurrentUser();

    if (LxcError.check(response)) {
      logout();
    } else {
      userSession.value = response;
      isAuthenticated.value =
        !!userSession.value?.login && userSession.value?.active;
    }
  }

  /**
   * Check if user is authenticated
   */
  function isAffectedToSectorCode(sectorCode: string): boolean {
    return !!userSession.value?.sectors
      .map((sector) => sector.code)
      .includes(`${sectorCode}`);
  }

  return {
    userSession,
    setCurrentUser,
    isAuthenticated,
    isAffectedToSectorCode,
  };
});
